<section class="fb-login w-full flex justify-center items-center min-h-[90vh] bg-[#fdf6ea]">
	<div class="w-full max-w-[956px] min-h-[60vh] bg-white rounded-2xl p-3 md:p-6 m-3 flex flex-col md:flex-row justify-between items-stretch">
		<div class="md:flex-[50%] rounded-2xl overflow-hidden relative flex justify-center items-center">
			<img ngSrc="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/FKQ1PKIMYJOD4S9PRTU8S10HUPIE00141.jpg"
				 width="400"
				 height="500"
				 class="w-full h-full object-cover"
				 alt="Anuprerna">
		</div>
		<div class="md:flex-[50%] flex justify-center items-center">
			<fb-verify-email-form/>
		</div>
	</div>
</section>
